import React from 'react';

import clsx from 'clsx';

import Button from 'components/common/Button/Button';
import { InactiveStatusTab } from 'components/applications/applications.enums';

import styles from './ApplicationsStatusGroup.module.scss';

const statusTabs: { id: InactiveStatusTab; label: string }[] = [
  { id: InactiveStatusTab.AllInactive, label: InactiveStatusTab.AllInactive },
  { id: InactiveStatusTab.Funded, label: InactiveStatusTab.Funded },
  { id: InactiveStatusTab.WillNotFund, label: InactiveStatusTab.WillNotFund },
];

interface ApplicationsStatusGroupProps {
  status: InactiveStatusTab;
  isLoading: boolean;
  onChange: (status: InactiveStatusTab) => void;
}

const ApplicationsStatusGroup: React.FC<ApplicationsStatusGroupProps> = ({ status, isLoading, onChange }) => (
  <div className={styles.statusGroup}>
    {statusTabs.map(({ id, label }) => (
      <Button
        variant="white"
        key={id}
        disabled={isLoading}
        onClick={() => onChange(id)}
        className={clsx({ [styles.active]: status === id })}
      >
        {label}
      </Button>
    ))}
  </div>
);

export default ApplicationsStatusGroup;
